module.exports = __webpack_public_path__ + "VIPH2.png?1ae069164c47edd6dcaa880ed35bcd70";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH2.png
// module id = 92
// module chunks = 0